import React from 'react';
import { Telephone } from 'react-bootstrap-icons';
import '../../views/ConcejoView.css';

const Presidencia = ({ presidencia }) => {
  return (
    <>
      {presidencia != null && (
        <div className="concejo-box">
          <div>
            <span className="concejo-nombre">Presidente:</span>{' '}
            <span className="concejo-sub"> {presidencia.nombrePresidente}</span>
          </div>
          <div>
            <span className="concejo-nombre">Vicepresidente:</span>{' '}
            <span className="concejo-sub"> {presidencia.nombreVicepresidente}</span>
          </div>
          <div>
            <span className="concejo-nombre">Secretaria Parlamentaria:</span>{' '}
            <span className="concejo-sub"> {presidencia.nombreSecretaria}</span>
          </div>
          <div>
            <span className="concejo-nombre">Secretaria de Actas:</span>{' '}
            <span className="concejo-sub"> {presidencia.nombreProsecretaria}</span>
          </div>
          <div>
            <span className="concejo-nombre">Secretaria a Cargo del Digesto:</span>{' '}
            <span className="concejo-sub">{presidencia.nombreSecretariaDigesto}</span>
          </div>
          <div className="concejo-nombre">
            <Telephone /> {presidencia.telefono}
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(Presidencia);
